export default __webpack_public_path__ + "aa88c252128ac8ff105557935cc7e89b.png";